import {SELFIE} from "utils/constants";
import produce from "immer";

const initialState = {
  type: SELFIE.PICTURE,
  isActivated: false,
  isAvatarHidden: false,
  isSavingPhoto: false,
  isSavingVideo: false,
  isRightHand: true,

  action: {
    command: "",
    name: "",
  },
};

const selfie = (state = initialState, action) => {
  const {type} = action;
  switch (type) {
    case SELFIE.TAKE_SELFIE:
      return produce(state, draft => {
        if (state.type === SELFIE.PICTURE) {
          draft.isSavingPhoto = true;
          draft.isSavingVideo = false;
        }
        draft.action = {
          command: type,
        };
      });
    case SELFIE.STOP_RECORD:
      return produce(state, draft => {
        draft.isSavingPhoto = false;
        draft.isSavingVideo = true;
        draft.action = {
          command: type,
        };
      });
    case SELFIE.SELFIE_ON:
      return produce(state, draft => {
        draft.isActivated = true;
        draft.action = {
          command: type,
        };
      });
    case SELFIE.SELFIE_OFF:
      return produce(state, draft => {
        draft.isActivated = false;
        draft.isRightHand = true;
        draft.type = SELFIE.PICTURE;
        draft.action = {
          command: type,
        };
      });
    case SELFIE.PICTURE:
      return produce(state, draft => {
        draft.type = type;
        draft.action = {
          command: "",
        };
      });
    case SELFIE.VIDEO:
      return produce(state, draft => {
        draft.type = type;
        draft.action = {
          command: "",
        };
      });
    case SELFIE.HIDE_AVATARS:
      return produce(state, draft => {
        draft.isAvatarHidden = !state.isAvatarHidden;
        draft.action = {
          command: type,
        };
      });
    case SELFIE.CLOSE_SAVE:
      return produce(state, draft => {
        draft.isSavingPhoto = false;
        draft.isSavingVideo = false;
        draft.action = {
          command: type,
        };
      });
    case SELFIE.SWITCH_HAND:
      return produce(state, draft => {
        draft.isRightHand = !draft.isRightHand;
        draft.action = {
          command: type,
        };
      });
    default:
      return state;
  }
};

export default selfie;
